(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('ss-proyectos-facultad', {
            parent: 'entity',
            url: '/ss-proyectos-facultad',
            data: {
                authorities: ['RESPONSABLE_DE_SS_DE_FACULTAD'],
                pageTitle: 'SSProyectosFacultad'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/s-s-proyecto/ss-proyecto-fac.html',
                    controller: 'SSProyectoFacultadController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            	periodos: ['SSPeriodo', function(SSPeriodo){
            		return SSPeriodo.all().$promise;
            	}],
	        	programasEducativos: ['ProgramaEducativo', function(ProgramaEducativo){
	        		return ProgramaEducativo.getByCurrentUser().$promise;
	        	}],
	        	estatusProyectos: function () {
                	return ["APROBADO", "DICTAMEN", "REGISTRADO", "NO_APROBADO", "BAJA_TEMPORAL", "BAJA_DEFINITIVA"];
                }
            }
        })
        .state('ss-proyecto-facultad-detail', {
            parent: 'ss-proyectos-facultad',
            url: '/detail/{id}',
            data: {
                authorities: ['RESPONSABLE_DE_SS_DE_FACULTAD'],
                pageTitle: 'SSProyecto'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/s-s-proyecto/ss-proyecto-fac-detail.html',
                    controller: 'SSProyectoDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            	entity: ['$stateParams', 'SSProyecto', function($stateParams, SSProyecto) {
            		return SSProyecto.getByCentroDocente({id : $stateParams.id});
            	}]
            }
        })
        .state('ss-proyectos-central', {
            parent: 'entity',
            url: '/ss-proyectos-central',
            data: {
                authorities: ['ADMINISTRADOR_DE_PROGRAMA_SS'],
                pageTitle: 'SSProyectosCentral'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/s-s-proyecto/ss-proyecto-central/ss-proyecto-central.html',
                    controller: 'SSProyectoCentralController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            	periodos: ['SSPeriodo', function(SSPeriodo){
            		return SSPeriodo.all().$promise;
            	}],
	        	centrosDocentes: ['CentroDocente', function(CentroDocente){
	        		return CentroDocente.all().$promise;
	        	}],
	        	estatusProyectos: function () {
                	return ["REGISTRADO", "DICTAMEN", "APROBADO", "EDICION", "REPLANTEADO", "NO_APROBADO", "BAJA_TEMPORAL", "BAJA_DEFINITIVA"];
                }
            }
        })
        .state('ss-proyecto-central-detail', {
            parent: 'ss-proyectos-central',
            url: '/detail/{id}',
            data: {
                authorities: ['ADMINISTRADOR_DE_PROGRAMA_SS'],
                pageTitle: 'SSProyecto'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/s-s-proyecto/ss-proyecto-central/ss-proyecto-central-detail.html',
                    controller: 'SSProyectoDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            	entity: ['$stateParams', 'SSProyecto', function($stateParams, SSProyecto) {
            		return SSProyecto.get({id : $stateParams.id});
            	}] 
            }
        })
        .state('ss-proyectos-comite', {
            parent: 'entity',
            url: '/ss-proyectos-comite',
            data: {
                authorities: ['MIEMBRO_COMITE_SS'],
                pageTitle: 'SSProyectosComite'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/s-s-proyecto/ss-proyecto-comite.html',
                    controller: 'SSProyectoComiteController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            	periodos: ['SSPeriodo', function(SSPeriodo){
            		return SSPeriodo.all().$promise;
            	}],
	        	centrosDocentes: ['CentroDocente', function(CentroDocente){
	        		return CentroDocente.all().$promise;
	        	}],
	        	estatusProyectos: function () {
                	return ["DICTAMEN", "APROBADO", "REPLANTEADO", "NO_APROBADO"];
                }
            }
        })
        .state('ss-editar-vigencia', {
            parent: 'ss-proyectos-central',
            url: '/{id}/editar-vigencia',
            data: {
                authorities: ['ADMINISTRADOR_DE_PROGRAMA_SS'],
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/s-s-proyecto/ss-editar-vigencia-dialog.html',
                    controller: 'EditarVigenciaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        entity: ['SSProyecto', function(SSProyecto) {
                            return SSProyecto.getSolicitud({id : $stateParams.id}).$promise;
                        }]

                    }
                }).result.then(function() {
                	$state.go('ss-proyectos-central', null, { reload: 'ss-proyectos-central' });
                }, function() {
                    $state.go('^');
                });                
            }]
        })
        
        .state('ss-asignar', {
            parent: 'ss-proyecto-facultad-detail',
            url: '/{periodo}/asignar/{perfil}',
            data: {
                authorities: ['RESPONSABLE_DE_SS_DE_FACULTAD'],
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/s-s-proyecto/ss-asignar-dialog.html',
                    controller: 'AsignarDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                            	perfil: null,
                            	asignacion: {
                                    iniPrestacion: null,
                                    finPrestacion: null,
                                    duracionHoras: null,
                                    estatusPrestador: null,
                                    altaReg: null,
                                    bajaReg: null,
                                    ultActReg: null,
                                    activo: null,
                                    usuarioUltAct: null,
                                    expediente: null,
                                    fechaLiberacion: null,
                                    id: null,
                                    respDePrestador: null,
                                    prestador: null,
                                    perfil: null                          		
                            	},
                            	unidadReceptora: null,
                            	periodo: null
                            };
                        },
                        sSProyecto: ['SSProyecto', function(SSProyecto) {
                            return SSProyecto.getSolicitud({id : $stateParams.id}).$promise;
                        }],
                        sSPerfil: ['SSPerfil', function(SSPerfil) {
                            return SSPerfil.get({id : $stateParams.perfil}).$promise;
                        }],
                        sSPeriodo: ['SSPeriodo', function(SSPeriodo) {
                            return SSPeriodo.get({id : $stateParams.periodo}).$promise;
                        }]

                    }
                }).result.then(function() {
                	$state.go('^', {id : $stateParams.id}, { reload: 'ss-proyecto-facultad-detail' });
                }, function() {
                	$state.go('^', {id : $stateParams.id}, { reload: false });
                });
            }]
        })
        .state('ss-cancelar-baja', {
        	parent: 'ss-proyecto-facultad-detail',
            url: '/cancelar-baja/{asig}',
            data: {
            	authorities: ['RESPONSABLE_DE_SS_DE_FACULTAD'],
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/s-s-proyecto/ss-cancelar-baja-dialog.html',
                    controller: 'CancelarBajaController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['SSAsignacion', function(SSAsignacion) {
                            return SSAsignacion.get({id : $stateParams.asig}).$promise;
                        }]
                    }
                }).result.then(function() {
                	$state.go('^', {id : $stateParams.id}, { reload: 'ss-proyecto-facultad-detail' });
                }, function() {
                	$state.go('^', {id : $stateParams.id}, { reload: false });
                });
            }]
        })
        .state('ss-liberar', {
            parent: 'ss-proyecto-facultad-detail',
            url: '/liberar/{asig}',
            data: {
                authorities: ['RESPONSABLE_DE_SS_DE_FACULTAD'],
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/s-s-proyecto/ss-liberar-dialog.html',
                    controller: 'LiberarDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        entity: ['SSAsignacion', function(SSAsignacion) {
                            return SSAsignacion.get({id : $stateParams.asig}).$promise;
                        }]
                    }
                }).result.then(function() {
                	$state.go('^', {id : $stateParams.id}, { reload: 'ss-proyecto-facultad-detail' });
                }, function() {
                	$state.go('^', {id : $stateParams.id}, { reload: false });
                });
            }]
        })
        .state('ss-cambiar-fechas', {
            parent: 'ss-proyecto-central-detail',
            url: '/cambiar-fechas/{asig}',
            data: {
                authorities: ['ADMINISTRADOR_DE_PROGRAMA_SS'],
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/s-s-proyecto/ss-cambiar-fechas-dialog.html',
                    controller: 'CambiarFechasDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        entity: ['SSAsignacion', function(SSAsignacion) {
                            return SSAsignacion.get({id : $stateParams.asig}).$promise;
                        }],
                        previousState: ["$state", function ($state) {
                        	var currentStateData = {
								name: $state.current.name || 'ss-proyecto',
								params: $state.params,
								url: $state.href($state.current.name, $state.params)
                        	};
                        	return currentStateData;
                        }]
                    }
                }).result.then(function() {
                	$state.go('^', {id : $stateParams.id}, { reload: 'ss-proyecto-central-detail' });
                }, function() {
                	$state.go('^', {id : $stateParams.id}, { reload: false });
                });
            }]
        })
        .state('ss-cancelar-asignacion', {
        	parent: 'ss-proyecto-central-detail',
            url: '/cancelar-asignacion/{asig}',
            data: {
            	authorities: ['ADMINISTRADOR_DE_PROGRAMA_SS'],
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/s-s-proyecto/ss-cancelar-asignacion-dialog.html',
                    controller: 'CancelarAsignacionController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['SSAsignacion', function(SSAsignacion) {
                            return SSAsignacion.get({id : $stateParams.asig}).$promise;
                        }]
                    }
                }).result.then(function() {
                	$state.go('^', {id : $stateParams.id}, { reload: 'ss-proyecto-central-detail' });
                }, function() {
                	$state.go('^', {id : $stateParams.id}, { reload: false });
                });
            }]
        })
		.state('ss-cancelar-liberacion', {
			parent: 'ss-proyecto-central-detail',
			url: '/cancelar-liberacion/{asig}',
			data: {
				authorities: ['ADMINISTRADOR_DE_PROGRAMA_SS'],
			},
			onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
				$uibModal.open({
					templateUrl: 'app/entities/s-s-proyecto/ss-cancelar-liberacion-dialog.html',
				    controller: 'CancelarLiberacionController',
				    controllerAs: 'vm',
				    size: 'md',
				    resolve: {
				        entity: ['SSAsignacion', function(SSAsignacion) {
				        	return SSAsignacion.get({id : $stateParams.asig}).$promise;
				    	}]
					}
				}).result.then(function() {
					$state.go('^', {id : $stateParams.id}, { reload: 'ss-proyecto-central-detail' });
				}, function() {
					$state.go('^', {id : $stateParams.id}, { reload: false });
				});
			}]
		})
        .state('ss-cambiar-fechas-confirmacion', {
            parent: 'ss-proyecto-central-detail',
            url: '/cambiar-fechas/{asig}/confirmacion',
            data: {
                authorities: ['ADMINISTRADOR_DE_PROGRAMA_SS'],
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/s-s-proyecto/ss-cambiar-fechas-confirmacion-dialog.html',
                    controller: 'SSCambiarFechasConfirmacionController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        entity: ['SSAsignacion', function(SSAsignacion) {
                            return SSAsignacion.get({id : $stateParams.asig}).$promise;
                        }],
                        previousState: ["$state", function ($state) {
                        	var currentStateData = {
								name: $state.current.name || 'ss-proyecto',
								params: $state.params,
								url: $state.href($state.current.name, $state.params)
                        	};
                        	return currentStateData;
                        }]
                    }
                }).result.then(function() {
                	$state.go('ss-cambiar-fechas', {asig : $stateParams.asig});
                }, function() {
                	$state.go('^', {id : $stateParams.id}, { reload: false });
                });
            }]
        })
        .state('ss-certificar', {
            parent: 'ss-proyecto-central-detail',
            url: '/certificar/{asig}',
            data: {
                authorities: ['ADMINISTRADOR_DE_PROGRAMA_SS', 'RESPONSABLE_DE_SS_DE_FACULTAD'],
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/s-s-proyecto/ss-certificar-dialog.html',
                    controller: 'CertificarDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        entity: ['SSAsignacion', function(SSAsignacion) {
                            return SSAsignacion.get({id : $stateParams.asig}).$promise;
                        }],
                        previousState: ["$state", function ($state) {
                        	var currentStateData = {
								name: $state.current.name || 'ss-proyecto',
								params: $state.params,
								url: $state.href($state.current.name, $state.params)
                        	};
                        	return currentStateData;
                        }]
                    }
                }).result.then(function() {
                	$state.go('^', {id : $stateParams.id}, { reload: 'ss-proyecto-central-detail' });
                }, function() {
                	$state.go('^', {id : $stateParams.id}, { reload: false });
                });
            }]
        })
        .state('ss-dar-baja', {
            parent: 'ss-proyecto-facultad-detail',
            url: '/baja/{asig}',
            data: {
                authorities: ['RESPONSABLE_DE_SS_DE_FACULTAD'],
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/s-s-proyecto/ss-baja-dialog.html',
                    controller: 'BajaDialogController',
                    controllerAs: 'vm',
                    size: 'lg',
                    resolve: {
                        sSBaja: function () {
                            return {
                                fechaBaja: null,
                                tipoBaja: null,
                                motivo: null,
                                altaReg: null,
                                bajaReg: null,
                                ultActReg: null,
                                activo: null,
                                usuarioUltAct: null,
                                id: null,
                                asignacion: null
                            };
                        },
                        sSAsignacion: ['SSAsignacion', function(SSAsignacion) {
                            return SSAsignacion.get({id : $stateParams.asig}).$promise;
                        }]
                    }
                }).result.then(function() {
                	$state.go('^', {id : $stateParams.id}, { reload: 'ss-proyecto-facultad-detail' });
                }, function() {
                	$state.go('^', {id : $stateParams.id}, { reload: false });
                });
            }]
        })
        .state('ss-proyectos', {
            parent: 'entity',
            url: '/ss-proyectos',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'SSProyectos'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/s-s-proyecto/ss-proyecto.html',
                    controller: 'SSProyectoController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            	entity: ['$stateParams', 'SSPeriodo', function($stateParams, SSPeriodo) {
            		return SSPeriodo.all();
            	}] 
            }
        })
        .state('ss-proyecto-central-solicitud', {
            parent: 'ss-proyectos-central',
            url: '/solicitud/{id}',
            data: {
                authorities: ['ADMINISTRADOR_DE_PROGRAMA_SS'],
                pageTitle: 'SSProyectos'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/s-s-proyecto/ss-proyecto-solicitud/ss-proyecto-solicitud-admin.html',
                    controller: 'SSProyectoCentralSolicitudController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'SSProyecto', function($stateParams, SSProyecto) {
                    return SSProyecto.getSolicitud({id : $stateParams.id}).$promise;
                }],
                selectedTab: function () {
                	return 0;
                }
            }
        })
        .state('ss-proyecto-central-seguimiento', {
            parent: 'ss-proyectos-central',
            url: '/seguimiento/{id}',
            data: {
                authorities: ['ADMINISTRADOR_DE_PROGRAMA_SS'],
                pageTitle: 'SSProyectos'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/s-s-proyecto/ss-proyecto-solicitud/ss-proyecto-solicitud-admin.html',
                    controller: 'SSProyectoCentralSolicitudController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'SSProyecto', function($stateParams, SSProyecto) {
                    return SSProyecto.getSolicitud({id : $stateParams.id}).$promise;
                }],
                selectedTab: function () {
                	return 4;
                }
            }
        })
        .state('ss-proyecto-comite-solicitud', {
            parent: 'ss-proyectos-comite',
            url: '/solicitud/{id}',
            data: {
                authorities: ['MIEMBRO_COMITE_SS'],
                pageTitle: 'SSProyectos'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/s-s-proyecto/ss-proyecto-solicitud/ss-proyecto-solicitud-admin.html',
                    controller: 'SSProyectoComiteSolicitudController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'SSProyecto', function($stateParams, SSProyecto) {
                    return SSProyecto.getSolicitud({id : $stateParams.id}).$promise;
                }],
                selectedTab: function () {
                	return 0;
                }
            }
        })
        .state('ss-proyecto-comite-seguimiento', {
            parent: 'ss-proyectos-comite',
            url: '/seguimiento/{id}',
            data: {
                authorities: ['MIEMBRO_COMITE_SS'],
                pageTitle: 'SSProyectos'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/s-s-proyecto/ss-proyecto-solicitud/ss-proyecto-solicitud-admin.html',
                    controller: 'SSProyectoComiteSolicitudController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'SSProyecto', function($stateParams, SSProyecto) {
                    return SSProyecto.getSolicitud({id : $stateParams.id}).$promise;
                }],
                selectedTab: function () {
                	return 4;
                }
            }
        })
	    .state('ss-proyecto-facultad-solicitud', {
	        parent: 'ss-proyectos-facultad',
	        url: '/solicitud/{id}',
	        data: {
	            authorities: ['RESPONSABLE_DE_SS_DE_FACULTAD'],
	            pageTitle: 'SSProyectos'
	        },
	        views: {
	            'content@': {
	                templateUrl: 'app/entities/s-s-proyecto/ss-proyecto-solicitud/ss-proyecto-solicitud-admin.html',
	                controller: 'SSProyectoFacultadSolicitudController',
	                controllerAs: 'vm'
	            }
	        },
	        resolve: {
	            entity: ['$stateParams', 'SSProyecto', function($stateParams, SSProyecto) {
	                return SSProyecto.getSolicitud({id : $stateParams.id}).$promise;
	            }],
	            selectedTab: function () {
	            	return 0;
	            }
	        }
	    })
	    .state('ss-proyecto-facultad-seguimiento', {
	        parent: 'ss-proyectos-facultad',
	        url: '/seguimiento/{id}',
	        data: {
	            authorities: ['RESPONSABLE_DE_SS_DE_FACULTAD'],
	            pageTitle: 'SSProyectos'
	        },
	        views: {
	            'content@': {
	                templateUrl: 'app/entities/s-s-proyecto/ss-proyecto-solicitud/ss-proyecto-solicitud-admin.html',
	                controller: 'SSProyectoFacultadSolicitudController',
	                controllerAs: 'vm'
	            }
	        },
	        resolve: {
	            entity: ['$stateParams', 'SSProyecto', function($stateParams, SSProyecto) {
	                return SSProyecto.getSolicitud({id : $stateParams.id}).$promise;
	            }],
	            selectedTab: function () {
	            	return 4;
	            }
	        }
	    })
        .state('ss-proyectos-delete', {
            parent: 'ss-proyectos',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/s-s-proyecto/ss-proyecto-delete-dialog.html',
                    controller: 'SSProyectoDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['SSProyecto', function(SSProyecto) {
                            return SSProyecto.getSolicitud({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('ss-proyectos', null, { reload: 'ss-proyectos' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }
})();
